import React from "react";
import "./NotFound.sass";

export const NotFound = () => {

    return <div className="NotFound-wrapper">
        <div className="NotFound-message">Такой страницы не существует ;)</div>
    </div>
}